/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LiffContactInfo = {
    contactInfoType?: LiffContactInfo.contactInfoType;
    contactInfo?: string;
};
export namespace LiffContactInfo {
    export enum contactInfoType {
        CUSTOM_LINK = 'CUSTOM_LINK',
        LINE_OA_CHAT = 'LINE_OA_CHAT',
    }
}

